import checkPwd from '@/pages/system/checkPwd';
import remind from '@/pages/system/remind';

const systemRouter = [
  {
    path: '/system/checkPwd', name: 'checkPwd', component: checkPwd, meta: { c: 'system', a: 'checkPwd' },
  },
  {
    path: '/system/remind', name: 'remind', component: remind, meta: { c: 'system', a: 'remind' }
  },
];

export default systemRouter;
